import React from 'react';
import { Theme } from '@theme/base';
import { TestId } from '@components/test-ids';
import Grid from '@mui/material/Grid';
import { Country, Region, Resort, SortDirection } from '@model/common';
import { withTheme } from '@emotion/react';
import { sortByField } from '@util/common';
import { getDestinationResorts } from '@util/destination';
import { TileContainer } from './tile/TileContainer';
import styled from '@emotion/styled';

export interface ResortListProps {
  theme: Theme;
  destination: Country | Region;
}

const Container = styled.div({});

export const ResortListComponent = ({ theme, destination }: ResortListProps) => {
  if (!destination) return null;

  const resorts = getDestinationResorts(destination);

  const getSortedResorts: () => Array<Resort> = () => sortByField(resorts, 'display', SortDirection.ASC);

  return (
    <Container data-testid={TestId.resortGroup.group}>
      <Grid container spacing={theme!.custom.gridSpacing.default}>
        {getSortedResorts().map((resort: Resort) => (
          <Grid key={resort.path} item xs={12} sm={6} md={4}>
            <TileContainer key={resort.path} resort={resort} />
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export const ResortList = withTheme(ResortListComponent);
